import { render } from "./errorBlock.vue?vue&type=template&id=0d8a4b48&scoped=true"
import script from "./errorBlock.vue?vue&type=script&lang=js"
export * from "./errorBlock.vue?vue&type=script&lang=js"

import "./errorBlock.vue?vue&type=style&index=0&id=0d8a4b48&scoped=true&lang=css"

import exportComponent from "/home/learnbil/public_html/learnbilly.com/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8a4b48"]])

export default __exports__